//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Paginate from 'vuejs-paginate';
import tabelaCommonsMixin from '../../../../shared-components/generico/tabelaCommonsMixin';
import TabelaGenerica from '../../../../shared-components/generico/TabelaGenerica';
import mdChipsAutocomplete from '../../../../shared-components/chipsautocomplete/mdChipsAutocomplete';
import mdAutocomplete from '../../../../shared-components/autocomplete/mdAutocomplete';

import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  extends: TabelaGenerica,
  mixins: [tabelaCommonsMixin],
  data() {
    return {
      centroCustoResources: this.$api.centroCusto(this.$resource),
      bloquearBotaoExportacao: false,
      centroCustos: [],
      esperar: false,
      headers: [
        { text: this.$tc('label.cod_centro_custo', 1), value: 'id_externo' },
        { text: this.$tc('label.nome', 1), value: 'nome' },
      ],
      pagination: {},
      totalPage: 0,
      searchQuery: '',
      selected: [],
      statusFilter: 'true',
    };
  },
  props: {
    fetchExtensaoFunction: Function,
    prepareResponseData: Function,
    statusFilter: {
      type: String,
      default: 'true',
    },
  },
  components: {
    mdChipsAutocomplete,
    mdAutocomplete,
    Paginate,
  },
  computed: {
    ...generateComputed('Ceco', [
      'canAccessCRUD',
    ]),
    centroCustoFilteredList() {
      return this.filteredList.map((linha) => {
        const row = Object.assign({}, linha);

        row.dependencias = this.stringToArray(linha);

        return row;
      });
    },
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
    searchQuery(novoValor) {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.$emit('TABELA_FILTRAR_PAGINA', novoValor);
        // this.filtrar();
      }, 500);
    },
    paginationSize(valor) {
      this.$emit('PAGINACAO_ALTERANDO_TAMANHO_PAGINA', valor);
    },
  },
  methods: {
    buscar() {
      if (this.searchQuery) {
        this.pagination.page = 1;
      }
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar();
      }, 5E2);
    },
    getSearchQuery() {
      return this.searchQuery;
    },
    extractCanaisName(row) {
      return row.dependencias.canais.map(el => el.nomExtensao).join(', ');
    },
    extractMarcasName(row) {
      return row.dependencias.marcas.map(el => el.nomExtensao).join(', ');
    },
    fetchSuperiorCanalFunction() {
      return this.fetchExtensaoFunction({
        nome: this.$refs.canalAutoComplete['0'].$refs.autocomplete.query,
        idNivelExtensao: 3,
      });
    },
    fetchSuperiorMarcaFunction() {
      return this.fetchExtensaoFunction({
        nome: this.$refs.marcaAutoComplete['0'].$refs.autocomplete.query,
        idNivelExtensao: 2,
      });
    },
    fetchSuperiorUnidadeNegocioFunction() {
      return this.fetchExtensaoFunction({
        nome: this.$refs.unidadeNegocioAutoComplete['0'].query,
        idNivelExtensao: 1,
      });
    },
    setUnidadeNegocio(hit, row) {
      const unidadeNegocio = {
        id: hit.id,
        nomExtensao: hit.nomExtensao,
      };
      this.updateItemDependency(row, 'unidadeNegocio', unidadeNegocio);
    },
    updateItemDependency(row, property, dependency) {
      const item = Object.assign({}, row);
      item.dependencias[property] = dependency;
      this.$emit('TABELAGENERICA_ATUALIZAR', item);
      this.cleanEdition();
    },
    stringToArray(linha) {
      if (typeof linha.canais !== 'string' && typeof linha.marcas !== 'string') {
        return linha.dependencias;
      }

      const canaisObj = !linha.canais ? [] : linha.canais.split(',').map((cat) => {
        const canaisStr = cat.split(':');
        return {
          id: parseInt(canaisStr[0], 10),
          nomExtensao: canaisStr[1],
        };
      });

      const marcasObj = !linha.marcas ? [] : linha.marcas.split(',').map((cat) => {
        const marcasStr = cat.split(':');
        return {
          id: parseInt(marcasStr[0], 10),
          nomExtensao: marcasStr[1],
        };
      });

      const unidadeNegocioStr = linha.unidadenegocio.split(':');
      const unidadeNegocioObj = {
        id: parseInt(unidadeNegocioStr[0], 10),
        nomExtensao: unidadeNegocioStr[1],
      };

      return {
        canais: canaisObj,
        marcas: marcasObj,
        unidadeNegocio: unidadeNegocioObj,
      };
    },
    validadeUpdateItem(row, rowIndex, columnIndex) {
      if (row.indCliente === false && row.indProduto === false) {
        this.$toast.create(this.$t('message.erro_salvar_centro_sem_produto_cliente'), 'snack', 5E3);
        return;
      }

      this.updateItem(row, rowIndex, columnIndex);
      this.currentEditItem = null;
    },
    handleStatusFilterChange() {
      this.paginationPage = 0;
      this.$emit('TABELA_FILTRAR_STATUS', this.statusFilter);
      this.filtrar();
    },
  },
  mounted() {
    this.filtrar();
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/centro-custo/CentroCustoTabela.vue?vue&type=script&lang=js&